var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-5"},[_c('v-col',{attrs:{"cols":"7"}},[_c('variable-radius-pie',{attrs:{"options":_vm.api.reachStats}})],1),_c('v-col',{staticClass:"d-flex flex-column justify-center",attrs:{"cols":"5"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }